import React from 'react'
import { RiGroupLine } from "react-icons/ri";
import { GoLightBulb } from "react-icons/go";
import { FaRegHeart } from "react-icons/fa6";
import { MdOutlineShowChart } from "react-icons/md";

function JoinTeam() {
 
  return (
    <>
    <section class="join_team_section">
  <div class="join_team_container">
    <h3>Join Our Team at Plus Distribution Pvt. Ltd.</h3>
    <p>
      PDPL offers exciting career opportunities for you! Join our dynamic team,
      committed to innovation, growth, and making a meaningful impact in the community.
    </p>
    <a className='btn' href='#openRole'>View Open Roles</a>
  </div>
</section>


   <section className="why_work_with_us_section">
      <div className="container">
        <h3>Why Work With Us</h3>
        <p className="subtitle">
          Join a company that's transforming healthcare access and delivery across India.
        </p>
        <div className="work_cards">
          <div className="work_card">
            <div className="icon_box"><RiGroupLine /></div>
            <h4>Collaborative Work Culture</h4>
            <p>We build lasting partnerships based on trust, shared values, and consistent excellence.</p>
          </div>

          <div className="work_card">
            <div className="icon_box"><GoLightBulb /></div>
            <h4>Client centric excellence</h4>
            <p>Deliver reliable healthcare that transforms how families live, heal, and thrive every day.</p>
          </div>

          <div className="work_card">
            <div className="icon_box"><MdOutlineShowChart /></div>
            <h4>Growth & Learning Opportunity</h4>
            <p>We improve healthcare through innovation and ethics, responsibility and growth.</p>
          </div>

          <div className="work_card">
            <div className="icon_box"><FaRegHeart /></div>
            <h4>Empowering Teams</h4>
            <p>We empower teams to innovate, collaborate, and excel.</p>
          </div>
        </div>
      </div>
    </section>
      
    </>
  )
}

export default JoinTeam
